import { UserType, TelegramThemeParams } from '../common/commonTypes';

export const decodeTelegramUrlParams = (url: string) => {
    const urlParams = new URLSearchParams(url);
    const result: {
        tgData: Record<string, string> | null;
        user: UserType | null;
        themeParams: TelegramThemeParams | null;
    } = {
        tgData: null,
        user: null,
        themeParams: null,
    };

    // Decode tgWebAppData as a query string
    const rawTgWebAppData = urlParams.get('tgWebAppData');
    if (rawTgWebAppData) {
        try {
            const tgDataParams = new URLSearchParams(
                decodeURIComponent(rawTgWebAppData)
            );
            const parsedData: Record<string, string> = {};
            tgDataParams.forEach((value, key) => {
                parsedData[key] = value;
            });
            result.tgData = parsedData;

            // Parse user data if present
            if (parsedData.user) {
                result.user = JSON.parse(parsedData.user) as UserType;
            }
        } catch (error) {
            console.error('Failed to parse tgWebAppData:', error);
        }
    }

    // Decode tgWebAppThemeParams as JSON
    const rawThemeParams = urlParams.get('tgWebAppThemeParams');
    if (rawThemeParams) {
        try {
            result.themeParams = JSON.parse(
                decodeURIComponent(rawThemeParams)
            ) as TelegramThemeParams;
        } catch (error) {
            console.error('Failed to parse tgWebAppThemeParams:', error);
        }
    }

    return result;
};
